// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { BrowserStorageCache } from './BrowserStorageCache';
import { InMemoryCache } from './InMemoryCache';
export { BrowserStorageCache, InMemoryCache };
// Standard `Cache` export to maintain interoperability with React Native
export { BrowserStorageCache as Cache };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-amplify/cache/lib-esm/index.js
// module id = null
// module chunks = 